import { faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ExpComponent = ({ className = '' }) => {
  return <FontAwesomeIcon icon={faAngleDoubleUp} className={'text-info ' + className} fixedWidth={true} />;
};

export { ExpComponent as Exp };
